export default __webpack_public_path__ + "static/banner-budgeting-for-you-and-your-bump-2740de5cd16c0bc0fc44c836712efe37.jpg";